import { Divider } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { IResultGetRelated, OpService } from "../../../../../util/services/operation";
import { OPERATION_TYPE, VIEW_SMOOTH } from "../../../../../util/varibles/constants";
import { getElById, getLink, LINK_ID, onOpenPage } from "../../../../../util/varibles/global";
import LoadingBox from "../../../../LoadingBox";
import styles from "./style.module.scss";

interface IProps {
    op: {
        related_id?: string
        tenant_id: string
        id: string
        operation_code: string
        operation_type: OPERATION_TYPE
        vessel_id?: string
    }
    vesselName?: string
    onClose?(): void
}

const SupportOp: React.FC<IProps> = ({ op, vesselName = "", onClose }) => {
    const { related_id = "", tenant_id, id } = op;
    const infoRef = useRef({ related_id, tenant_id })
    const [{ loading, data }, setSource] = useState<{ loading: boolean, data: IResultGetRelated[] }>({ loading: false, data: [] })

    useEffect(() => {
        const { related_id, tenant_id } = infoRef.current;
        if (related_id.length > 0) {
            setSource({ loading: true, data: [] })
            OpService.getOpRelated({ related_id, tenant_id })
                .then(rs => {
                    setSource({ loading: false, data: rs })
                })
                .catch(err => {
                    setSource({ loading: false, data: [] })
                })
        }
    }, []);

    const handleClick = (e: React.MouseEvent, targetId: string) => {
        const el = getElById(targetId);
        if (el) {
            el.scrollIntoView(VIEW_SMOOTH);
            el.style.transform = 'scale(1.04)';
            setTimeout(() => {
                el.style.transform = '';
            }, 400)
            onClose?.();
        } else {
            const link = getLink[LINK_ID.OP_DETAIL]([tenant_id, targetId]);
            onOpenPage(e, link)
        }
    }

    const displayData = useMemo<IResultGetRelated[]>(() => data.length > 0 ? data : [{
        id,
        vessel_id: op.vessel_id,
        vessel_name: vesselName,
        operation_code: op.operation_code,
        operation_type: op.operation_type,
        est_start_time: 0,
        est_finish_time: 1
    }], [data, id, op.operation_code, op.operation_type, op.vessel_id, vesselName]);

    const { begin, duration } = useMemo(() => {
        const { begin, end } = displayData.reduce((rs: { begin: number, end: number }, item) => {
            rs.begin = Math.min(rs.begin, item.est_start_time);
            rs.end = Math.max(rs.end, item.est_finish_time);
            return rs;
        }, { begin: displayData[0].est_start_time, end: displayData[0].est_finish_time })
        return { begin, duration: end - begin }
    }, [displayData]);

    return <div className={styles.relatedOps} style={{
        '--begin': begin,
        '--duration': duration
    } as any}>
        {loading && <LoadingBox className="m-auto pt-3" loading level="bg" />}
        {displayData.map(item => {
            const isCurrentVessel = data.length === 0 || (!!op.id && item.id === op.id);

            return <div
                key={item.id}
                className={styles.op}
                data-is-main={data.length === 0 || item.operation_type !== OPERATION_TYPE.SUPPORT}
                data-is-single={displayData.length === 1}
                data-is-current={isCurrentVessel}
                style={{
                    '--op-left': item.est_start_time,
                    '--op-width': item.est_finish_time - item.est_start_time
                } as any}
            >
                <div className="flex items-center justify-center z-10 relative px-1 w-full truncate" title={`${item.vessel_name} | #${item.operation_code}`}>
                    <div className={[isCurrentVessel ? 'font-[600]' : '', 'truncate leading-none'].join(' ')}>{item.vessel_name}</div>
                    {item.id !== id && <>
                        <Divider className='h-[18px]' orientation="vertical" />
                        <div className="link truncate" onClick={(e) => handleClick(e, item.id)}>#{item.operation_code}</div>
                    </>}
                </div>
            </div>
        })}
    </div>
}

export default SupportOp
